import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
  ru: { translation: ru },
};

// Get initial language from localStorage or default to 'en'
const initialLanguage = localStorage.getItem('language') || 'en';

// Set HTML lang attribute immediately on page load
document.documentElement.lang = initialLanguage;

// Update HTML lang attribute on subsequent language changes at runtime
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng;
});

// i18next automatically includes pluralization rules for most languages
i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  pluralSeparator: '_', // This is the default separator for plural forms
});

export default i18n;
